import { _fetch } from "..";
import { API_V2_BASE_URL } from "../../constants/api";

export type ShopifyReauthStatus = "ok" | "reauth_required";

export interface ShopifyReauthUrlResponse {
  status: ShopifyReauthStatus;
  redirectUrl?: string;
}

export const fetchShopifyReauthUrl = (): Promise<ShopifyReauthUrlResponse> =>
  _fetch({
    method: "GET",
    endpoint: `${API_V2_BASE_URL}/shopifyApps/portal/reauth-url`,
    credentials: "include",
  });
